import React from 'react';
import ConfirmationDialog from '../../ConfirmationDialog';
import ApprovalDialogBody from '../ApprovalDialogBody';

const RequestDialog = ({ msg, onClose, onAccept, ...props }) =>
    <ConfirmationDialog
        {...props}
        onClose = { onClose }
        cancelButton={{
            action: onClose,
            label: 'NO, CANCEL'
        }}
        acceptButton={{
            action: onAccept,
            label: 'YES, REQUEST'
        }}
        header="Do you confirm that  you Request this Exception?"
        body={<ApprovalDialogBody msg={msg} />}

    />;

export default RequestDialog;